import React from "react";
import "./App.css";
import Navbar from "./components/portfolio/Navbar";
import HeroSection from "./components/portfolio/HeroSection";
import AboutSection from "./components/portfolio/AboutSection";
import ExperienceSection from "./components/portfolio/ExperienceSection";
import SkillsSection from "./components/portfolio/SkillsSection";
import ProjectsSection from "./components/portfolio/ProjectsSection";
import BottomSections from "./components/portfolio/BottomSections";
import ERBackground from "./components/portfolio/ERBackground";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="app-wrapper">
      <div className="tech-grid-bg" />
      <ERBackground />
      <Navbar />
      <main className="relative">
        <ERBackground />
        <HeroSection />
        <AboutSection />
        <ExperienceSection />
        <SkillsSection />
        <ProjectsSection />
        <BottomSections />
      </main>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
